import '../../styles/taco.css';
import { ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router";
import ExecProvider from "../../providers/ExecProvider";
import { Blipset } from "../../components/Blips";
import bongo_left from "url:../../assets/taco/bongo-left.png";
import bongo_right from "url:../../assets/taco/bongo-right.png";
import cowbell from "url:../../assets/taco/cowbell.png";
import home_button from "url:../../assets/taco/home.png";
import menu_button from "url:../../assets/taco/menu.png";
import findus_button from "url:../../assets/taco/findus.png";
import logo2 from "url:../../assets/taco/LOGO2.png";
import beg from "url:../../assets/taco/beg.png";
import PlayerProvider from '../../providers/PlayerProvider';
import { SITE_INFO_TACO } from '../../providers/SitesProvider';
import TACOProvider from './TACOProvider';
import { TACOI } from './TACOI';

export function TACO0 () {
    const player = useContext(PlayerProvider.context);

    useEffect(() => {
        player.unlockSite(SITE_INFO_TACO.key);
    }, []);

    const page = useMemo(() => {
        return <TACOProvider>
            <div className="page-basic bg-taco v-box gap-64">
                <div className='height-32' />
                <TACONav />
                <div className='v-box gap-64 padding-16 center-all pos-rel'>
                    <Outlet />
                </div>
                <TACOFooter />
                <TACOI />
            </div>
        </TACOProvider>  
    }, []);

    return page;
}

function TACONav() {
    const nav = useNavigate();
    const tacoProvider = useContext(TACOProvider.context);

    return <div className='h-box gap-32 justify-start align-center pos-rel'>
        <div className='width-256 height-192 cursor-pointer pos-rel ' onClick={() => { nav('/tacobongo/' )}}>
            <TACOLogo />
            <LogoBongoDoggo />
        </div>
        <div className='height-128 cursor-pointer v-box center-all'>
            <img src={home_button} className='height-100p' onClick={() => { nav('/tacobongo/' )}} />
        </div>
        <div className='height-128 cursor-pointer v-box center-all'>
            <img src={menu_button} className='height-100p' onClick={() => { nav('/tacobongo/menu' )}} />
        </div>
        <div className='height-128 cursor-pointer v-box justify-end'>
            <img src={findus_button} className='height-100p' onClick={() => { nav('/tacobongo/findus' )}} />
        </div>
        <button className='pos-abs' onClick={() => {
            tacoProvider.enterGame();
        }} style={{
            right: 0,
            bottom: 0
        }}>Play the Bongo Dressup Game!</button>
    </div>
}

function LogoBongoDoggo() {
    return <img src={beg} className='pos-abs width-192' style={{ left: 32, bottom: 72 }} />
}

export function TACOLogo() {
    return <img src={logo2} className='pos-abs width-256' style={{ bottom: 0}}/>
}

export function TACOFooter() {
    const execProvider = useContext(ExecProvider.context);
    const showp = execProvider.cmds.includes('bongo-down') ? true : false;
    return <div className='v-box gap-16'>
        {/* <StampCollection stamps={[
            StampType.TROK,
            StampType.WTROK,
            StampType.Anime
        ]}/> */}
        <Blipset 
            pass='111222111'
            elements={[
                <img className="height-128" src={bongo_left} />,
                <img className="height-128" src={bongo_right} />
            ]}
            clear={
                <img className="height-64" src={cowbell} />
            }
            onSuccess={() => {
                execProvider.addCommand('bongo-down');
            }}
        />
        {/* <div className="h-box center-all">
            <a href={'/tacobongo/game'} className="text-taco-pink text-align-center">Help Bongo get a Bongo Meal!</a>
        </div> */}
        <div className="h-box width-100p center-all">
            <a href="" className="text-taco-pink font-taco-secondary text-24 text-center">Copyright 1998 Taco Bongo Inc.<br/>All Rights Reserved.&nbsp;All Snacks Allowed ;)</a>
        </div>
    </div>
}